import React from 'react'
import { match } from 'ts-pattern'
import { tw } from '~/utils/tw-merge'

interface AlertProps {
  children?: React.ReactNode
  color: 'red' | 'amber'
  icon?: React.ReactNode
}
export function Alert({ icon, children, color }: AlertProps) {
  return (
    <div
      className={tw(
        'rounded-xl p-3 flex gap-x-2 items-center',
        match(color)
          .with('red', () => 'bg-red-200 text-red-800 ')
          .with('amber', () => 'bg-amber-100 text-amber-800 ')
          .exhaustive()
      )}
    >
      {icon ? <div>{icon}</div> : null}
      <div>{children}</div>
    </div>
  )
}
